export default __webpack_public_path__ + "static/media/enviroment.bd88d8d6.png";